import _extends from "@babel/runtime-corejs3/helpers/extends";
import _ListDownIcon from "@sk/icons/lib/ListDownIcon";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useCallback } from 'react';
import AntdDropdownButton from 'antd/lib/dropdown/dropdown-button';
var DropdownButton = /*#__PURE__*/React.memo(props => {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var onVisibleChange = useCallback(() => setVisible(visible => !visible), []);
  return /*#__PURE__*/React.createElement(AntdDropdownButton, _extends({}, props, {
    onVisibleChange: onVisibleChange,
    icon: visible ? /*#__PURE__*/React.createElement(_ListDownIcon, {
      style: {
        transform: 'rotate(180deg)'
      }
    }) : /*#__PURE__*/React.createElement(_ListDownIcon, null),
    className: "sk-btn-group"
  }));
});
export default DropdownButton;